export default "__VITE_ASSET__19a38b12__"